const ROLES = {
  Administrator: "ROLE_ADMIN",
  Pending: "ROLE_PENDING",
  Disabled: "ROLE_DISABLED",
  User: "ROLE_USER",
};

module.exports = {
  ROLES,
};
